export default "__VITE_ASSET__DMvQCd7Q__"